import { Button } from '@/components/ui/button';
import { useDialogStore } from '@/store';

type Props = {
  clientName: string;
  clientID: number;
};

function ClientCol({ clientID, clientName }: Props) {
  const { openClientCardDialog } = useDialogStore();
  return (
    <div className="flex h-8 w-56 items-start justify-start">
      <Button
        variant="link"
        size="default"
        onClick={() => {
          openClientCardDialog(clientID);
        }}
      >
        <span className="whitespace-normal break-words text-right font-sans text-xs">
          {clientName}
        </span>
      </Button>
    </div>
  );
}

export default ClientCol;
